import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react"; 

const useProfilePhoto = () => {
  const { accounts, instance } = useMsal();
  const [graphtoken, setGraphtoken] = useState<string | null>();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchProfilePhoto = async () => {
      if (accounts.length > 0) {
        const request = {
          scopes: ["user.read"], 
          account: accounts[0],
        };

        try {
          const response = await instance.acquireTokenSilent(request);
          setGraphtoken(response.accessToken);
        } catch (error: any) {
          console.error("Error fetching access token:", error);
          setError(error);
        }
      }
    };

    fetchProfilePhoto();
  }, [accounts, instance]);

  return { error, graphtoken };
};

export default useProfilePhoto;
